import { NavLink } from "react-router-dom";
import "./Navbar.scss";
import user from "assets/images/navbar-icons/user-profile.svg";
import bamaLogo from "assets/images/bama-logo.png";
const Navbar = () => {
  return (
    <div className="custom-navbar">
      <div className="logo-container">
        <NavLink to="/" className="">
          <img className="logo-image" src={bamaLogo} alt="#" />
        </NavLink>
      </div>
      <div className="user-profile-container">
        <div className="user-profile">
          <span>کاربر</span>
          <span>.....</span>
        </div>
        <NavLink to="/user/profile" className="">
          <img className="user-profile-image" src={user} alt="#" />
        </NavLink>
      </div>
      <div className="hamburger-menu-placeholder"></div>
    </div>
  );
};

export default Navbar;
